import { TrackingEventIds } from "../../tracking/constants/TrackingEventIds";
import { ClientLoadTrackingEvent } from "../../tracking/ClientLoadTrackingEvent";
import { ImpressionTrackingEvent } from "../../tracking/ImpressionTrackingEvent";
import { TrackingCache } from "../../tracking/TrackingCache";
import { IEnvironmentGlobals } from "../IEnvironmentGlobals";

/**
 * Count impression for tracking backend
 * eventId: 8
 */
export const executeImpressionTrackingEvent = (env: IEnvironmentGlobals): void => {
    if (env.isLocal) {
        return;
    }

    // Compose impression tracking event
    let impressionEvent: ImpressionTrackingEvent = <ImpressionTrackingEvent>TrackingCache.getInstance().getEvent(TrackingEventIds.IMPRESSION);

    impressionEvent.accountId = env.accountId;
    impressionEvent.creative = env.campainVars.creative;
    impressionEvent.keyword = env.campainVars.keyword;
    impressionEvent.lp = env.campainVars.lp;
    impressionEvent.network = env.campainVars.network;
    impressionEvent.partnerId = env.campainVars.partnerId;
    impressionEvent.placement = env.campainVars.placement;
    impressionEvent.channelId = env.campainVars.channelId;
    impressionEvent.trafficSourceId = env.campainVars.trafficSource;
    impressionEvent.aid = env.campainVars.aid;
    impressionEvent.camp = env.campainVars.camp;
    impressionEvent.adgr = env.campainVars.adgr;
    impressionEvent.matchtype = env.campainVars.matchtype;
    impressionEvent.journeyHash = env.jsVariables.journeyHash;

    // execute tracking
    TrackingCache.getInstance().sendEvent(TrackingEventIds.IMPRESSION);
};

/**
 * Count impression for publisher backend
 * eventId: 30
 */
export const executeClientLoadTrackingEvent = (env: IEnvironmentGlobals): void => {
    if (env.isLocal) {
        return;
    }

    let clientLoadEvent: ClientLoadTrackingEvent = <ClientLoadTrackingEvent>TrackingCache.getInstance().getEvent(TrackingEventIds.CLIENT_LOAD);

    clientLoadEvent.cid = env.campainVars.channelId;
    clientLoadEvent.distributorId = env.distributorId;
    clientLoadEvent.gameId = env.gameId;
    clientLoadEvent.networkId = env.networkId;
    clientLoadEvent.websiteId = env.urlVariables.websiteId;
    clientLoadEvent.versionDate = env.versionDateGame;
    clientLoadEvent.accountId = env.accountId;

    // execute tracking
    TrackingCache.getInstance().sendEvent(TrackingEventIds.CLIENT_LOAD);
};
